module.exports = __webpack_public_path__ + "img/eagleEye2_6.2fa31a6a.png";